module.exports = __webpack_public_path__ + "img/45.8.TSS.aa0906ca.png";